e360.controller('EventMediaController', [
   '$scope',
   '$uibModal',
   '$sce',
   'session',
   'mediaApi',
   'dialogs',
   'filterServiceFactory',
   'Lightbox',
   'loader',
   'apiHelper',
   'titleService',

   function ($scope, $modal, $sce, session, mediaApi, dialogs, filterServiceFactory, Lightbox, loader, apiHelper, titleService) {
      $scope.filter = new filterServiceFactory({
         key: 'media',
         defaults: {
            campaignId: session.getCampaign().id,
            page: 1,
            limit: 20
         },
         properties: ['search', 'eventId', 'startDate', 'endDate', 'promoOptin'],
         callback: function(property) {
            locals.refresh();
         }
      });

      titleService.setTitle('Event Media');
      $scope.loader = loader;
      $scope.apiDomain = session.apiDomain();

      var locals = {
         lastQuery: '',
         init: function () {
            $scope.files = [];
            locals.refresh();
         },
         refresh: function () {
            var params = $scope.filter.inputs;

            var query = $.param(params);
            if (query !== locals.lastQuery) {
               loader.showSpinner();
               mediaApi.get(params).then(function (data) {
                  $scope.files = data.list;
                  $scope.total = data.total;
               })['finally'](function () {
                  loader.hide();
               });
               locals.lastQuery = query;
            }

         },
         downloadResult: function (job) {
            mediaApi.downloadZip(job);
         }
      };

      $scope.isImage = function (file) {
         return file.mimeType.indexOf('image') > -1;
      };

      $scope.isVideo = function (file) {
         return file.mimeType.indexOf('video') > -1;
      };

      $scope.download = function () {
         dialogs.confirm('The selected media will be zipped for download. If you have lots of media to compress, this may take several minutes. Continue?').then(function () {
            $modal.open({
               animation: true,
               templateUrl: 'download-media-modal.html',
               controller: 'DownloadEventMediaController',
               resolve: {
                  params: function () {
                     return $scope.filter.inputs;
                  }
               }
            }).result.then(locals.downloadResult);
         });
      };

      $scope.open = function (file) {
         Lightbox.openModal([{
            url: apiHelper.getApiUrl('media/' + file.id),
            thumbUrl: apiHelper.getApiUrl('media/' + file.id, {height: 240}),
            caption: [file.event, file.location, file.created].join(' - ')
         }], 0);
      };

      $scope.openVideo = function(file) {
         $modal.open({
            animation: true,
            templateUrl: 'view-media-video-modal.html',
            controller: 'ViewVideoMediaController',
            resolve: {
               file: file
            }
         });
      };

      locals.init();
   }
]);

e360.controller('ViewVideoMediaController',
   ['$scope', '$sce', '$uibModalInstance', 'file',
      function($scope, $sce, $modalInstance, file) {
         $scope.link = $sce.trustAsResourceUrl('//www.youtube.com/embed/' + file.youTubeID + '?autoplay=1');

         $scope.close = function() {
            $modalInstance.dismiss();
         };
      }
   ]
);

e360.controller('DownloadEventMediaController',
   ['$scope', '$interval', '$uibModalInstance', 'params', 'mediaApi',
      function ($scope, $interval, $modalInstance, params, mediaApi) {
         var locals = {
            getJobs: function () {
               mediaApi.getJobs().then(function (jobs) {
                  var job = _.find(jobs, function (j) {
                     return j.id === locals.jobId;
                  });
                  if (job && job.isFinished) {
                     $interval.cancel(locals.jobInterval);
                     $modalInstance.close(job);
                  }
               });
            }
         };

         mediaApi.createJob(params).then(function (jobId) {
            locals.jobId = jobId;
            locals.jobInterval = $interval(locals.getJobs, 1000);
         }, function (err) {
            $scope.jobError = err.data;
         });

         $scope.close = function () {
            $modalInstance.dismiss();
         };

         $scope.cancel = function () {
            if (locals.jobInterval) {
               $interval.cancel(locals.jobInterval);
            }
            $modalInstance.dismiss();
         };
      }]);
